import { captureException } from '@sentry/nextjs'
import { Component } from 'react'
import { Error as ErrorComponent } from './Error'
import type { ReactNode } from 'react'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

class ErrorBoundary extends Component<Props, State> {
  state: State = {
    hasError: false,
  }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error): void {
    captureException(Error('Client-side error', { cause: error }))
  }

  render() {
    const { hasError } = this.state
    const { children } = this.props

    if (hasError) {
      return <ErrorComponent statusCode={undefined} />
    }

    return children
  }
}

export default ErrorBoundary
